__turbopack_context__.v({
  "container": "LQWeRq_container",
  "map": "LQWeRq_map",
});
